import React, { Component } from "react";
import { Row, Col, Card, CardBody, Button, CardTitle } from "reactstrap";
import "bootstrap/dist/js/bootstrap.bundle";
import { Link } from "react-router-dom";
import AsyncSelect from "react-select/async";
import Select, { AriaOnFocus } from "react-select";

// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import { withTranslation } from "react-i18next";

import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { getLedgers, getPartyApi, getUnitAPI, updateLedgers } from "api";
import moment from "moment/moment";

// Table data

class TransactionList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      sizePerPage: 10,
      totalSize: 10,
      ledgerList: [],
      partyList: [],
      partyId: "",
      orderId: "",
      toDate: moment().format("YYYY-MM-DD"),
      fromDate: moment().subtract(1,"week").format("YYYY-MM-DD"),
      approveStatus: "",
      orderList: [],
      paymentStatus: "",
      printStatus: "",
      factoryList: [],
      factoryId: "",
    };
  }

  async componentDidMount() {
    const factoryList = await getUnitAPI({
      isInternal: false,
      name: null,
      page: 1,
      limit: 10,
    });
    if (
      factoryList &&
      factoryList.data &&
      Array.isArray(factoryList.data.factories)
    ) {
      this.setState({
        factoryList: factoryList.data.factories,
      });
    }
    const jangadList = await getLedgers({
      page: this.state.page,
      limit: this.state.sizePerPage,
      paymentStatus: this.state.paymentStatus,
      partyId: this.state.partyId,
    });
    this.setState({
      orderList: jangadList.data.ledger,
    });
    const partyList = await getPartyApi({
      page: null,
      limit: null,
      name: null,
      partyCode: null,
    });
    if (partyList && partyList.data && Array.isArray(partyList.data.parties)) {
      this.setState({ partyList: partyList.data.parties });
    }
    this.getStockList();
  }

  async getPartyList(inputValue) {
    const data = await getPartyApi({
      page: null,
      limit: null,
      name: null,
      partyCode: inputValue,
    });
    this.setState({
      partyList: data.data.parties,
    });
    if (Array.isArray(data.data.parties))
      return [
        { label: "All", value: "" },
        ...data.data.parties.map(x => {
          return { label: x.name, value: x.id };
        }),
      ];
    else return [];
  }

  async getFactoryList(inputValue) {
    const data = await getUnitAPI({
      isInternal: null,
      name: inputValue,
      page: null,
      limit: null,
    });
    if (data && data.data && Array.isArray(data.data.factories)) {
      this.setState({
        factoryList: data.data.factories,
      });
    }
    return this.state.factoryList.map(x => {
      return { label: x.name, value: x.id };
    });
  }

  async getStockList() {
    const data = await getLedgers({
      page: this.state.page,
      limit: this.state.sizePerPage,
      paymentStatus: this.state.paymentStatus,
      partyId: this.state.partyId,
      orderId: this.state.orderId,
      factoryId: this.state.factoryId,
      approveStatus: this.state.approveStatus,
      printStatus: this.state.printStatus,
      toDate: this.state.toDate,
      fromDate: this.state.fromDate,
    });
    this.setState({
      totalSize: data.data.count,
      ledgerList: data.data.ledger,
    });
  }

  async getJangadList(inputValue) {
    const data = await getLedgers({
      page: this.state.page,
      limit: this.state.sizePerPage,
      paymentStatus: this.state.paymentStatus,
      partyId: this.state.partyId,
      name: inputValue,
    });
    this.setState({
      orderList: data.data.ledger,
    });
    if (Array.isArray(data.data.ledger))
      return [
        { label: "All", value: "" },
        ...data.data.ledger.map(x => {
          return { label: x.id, value: x.id };
        }),
      ];
    else return [];
  }

  render() {
    const promiseOptionsOrder = inputValue =>
      new Promise(resolve => {
        setTimeout(() => {
          resolve(this.getJangadList(inputValue));
        }, 0);
      });
    const promiseOptionsFactory = inputValue =>
      new Promise(resolve => {
        setTimeout(() => {
          resolve(this.getFactoryList(inputValue));
        }, 0);
      });
    const promiseOptions = inputValue =>
      new Promise(resolve => {
        setTimeout(() => {
          resolve(this.getPartyList(inputValue));
        }, 0);
      });

    const columns = [
      {
        dataField: "id",
        text: "#",
        sort: true,
        hidden: true,
      },
      {
        dataField: "id",
        text: `${this.props.t("Ledger Id")}`,
        sort: true,
      },
      {
        dataField: "fromDate",
        text: `${this.props.t("From Date")}`,
        sort: true,
      },
      {
        dataField: "toDate",
        text: `${this.props.t("To Date")}`,
        sort: true,
      },
      {
        dataField: "partyName",
        text: `${this.props.t("Party Name")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.party?.name;
        },
      },
      {
        dataField: "factoryname",
        text: `${this.props.t("Factory Name")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.factory?.name;
        },
      },
      {
        dataField: "cgst",
        text: `${this.props.t("CGST")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.gst / 2;
        },
      },
      {
        dataField: "sgst",
        text: `${this.props.t("SGST")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.gst / 2;
        },
      },
      {
        dataField: "totalCost",
        text: `${this.props.t("Total Cost")}`,
        sort: true,
        formatter: (cell, row) => {
          let cost = 0;
          let totalWeight = 0;

          row.ledgerDetails.map(x => {
            cost += x.mainJangad.rate;
          });
          row.ledgerDetails.map(x => {
            totalWeight += x.mainJangad.jangads.reduce((prev, current) => {
              return prev.cycle < current.cycle ? prev : current;
            }).weight;
          });
          return cost * totalWeight;
        },
      },
      {
        dataField: "discount",
        text: `${this.props.t("Discount")}`,
        sort: true,
        formatter: (cell, row) => {
          return cell == null ? 0 : cell
        },
      },
      {
        dataField: "paymentType",
        text: `${this.props.t("Payment Type")}`,
        sort: true,
        formatter: (cell, row) => {
          return cell == "NA" ? "NA" : cell
        },
      },
      {
        dataField: "printStatus",
        text: `${this.props.t("Print Status")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.printStatus == "Yes" ? (
            <button className="btn-success-green border-0 py-2 px-3 rounded">
              Yes
            </button>
          ) : (
            <button className="btn-danger-red border-0 py-2 px-3 rounded">
              No
            </button>
          );
        },
      },
      {
        dataField: "approveStatus",
        text: `${this.props.t("Approve Status")}`,
        sort: true,
        formatter: (cell, row) => {
          if (cell == "Yes") {
            return (
              <button className="btn-success-green border-0 py-2 px-3 rounded">
                Yes
              </button>
            );
          } else if (cell == "Pending") {
            return (
              <button className="btn-warning-yellow border-0 py-2 px-3 rounded">
                Pending
              </button>
            );
          } else {
            return (
              <button className="btn-danger-red border-0 py-2 px-3 rounded">
                No
              </button>
            );
          }
        },
      },
      {
        dataField: "paymentStatus",
        text: `${this.props.t("Payment Status")}`,
        sort: true,
        formatter: (cell, row) => {
          if (row.paymentStatus == "Paid") {
            return (
              <button className="btn-success-green border-0 py-2 px-3 rounded">
                Paid
              </button>
            );
          } else if (row.paymentStatus == "Pending") {
            return (
              <button className="btn-warning-yellow border-0 py-2 px-3 rounded">
                Pending
              </button>
            );
          } else {
            return (
              <button className="btn-primary-blue border-0 py-2 px-3 rounded">
                Partial Pending
              </button>
            );
          }
        },
      },
      {
        dataField: "printDate",
        text: `${this.props.t("Print Date")}`,
        sort: true,
        formatter: (cell, row) => {
          if (cell != null) return moment(cell).format("DD-MM-YYYY");
        },
      },
      {
        dataField: "viewdetails",
        text: `${this.props.t("View Details")}`,
        formatter: (cell, row) => (
          <div>
            <Link
              to={{
                pathname: "/approve-status-update",
                query: {
                  isEdit: 2,
                  data: row,
                },
              }}
            >
              <button className="py-2 px-2 border-0 rounded ms-2">
                <img src="images/dashboard-images/edit.svg" />
              </button>
            </Link>
            <Link
              to={{
                pathname: "/approve-status-update",
                query: {
                  isEdit: 3,
                  data: row,
                },
              }}
            >
              <button className="py-2 px-2 border-0 rounded ms-2">
                <img src="images/dashboard-images/view.svg" />
              </button>
            </Link>
          </div>
        ),
      },
      {
        dataField: "invoicePrint",
        text: `${this.props.t("Invoice Print")}`,
        formatter: (cell, row) =>
          row.party?.name ? (
            <div>
              <Link
                to={{
                  pathname: row.approveStatus == "Yes" ? "/print-ledger-report" : "/transaction-list",
                  query: {
                    isEdit: 2,
                    data: row,
                  },
                }}
              >
                <button disabled={row.approveStatus == "Yes" ? false : true} className="py-2 px-2 border-0 rounded ms-2">
                  <img src="images/dashboard-images/print.svg" />
                </button>
              </Link>
              <Link
                to={{
                  pathname: row.approveStatus == "Yes" ? "/payment-cash" : "/transaction-list",
                  query: {
                    isEdit: 2,
                    data: row,
                  },
                }}
              >
                <button disabled={row.approveStatus == "Yes" ? false : true} className="py-2 px-2 border-0 rounded ms-2">
                  <img src="images/dashboard-images/invoice.svg" />
                </button>
              </Link>
            </div>
          ) : (
            <div>
              <Link 

                to={{
                  pathname: row.approveStatus == "Yes" ? "/external-print-ledger-report" : "/transaction-list",
                  query: {
                    isEdit: 2,
                    data: row,
                  },
                }}
              >
                <button disabled={row.approveStatus == "Yes" ? false : true} className="py-2 px-2 border-0 rounded ms-2">
                  <img src="images/dashboard-images/print.svg" />
                </button>
              </Link>
              <Link
                to={{
                  pathname: row.approveStatus == "Yes" ? "/payment-cash" : "/transaction-list",
                  query: {
                    isEdit: 2,
                    data: row,
                  },
                }}
              >
                <button disabled={row.approveStatus == "Yes" ? false : true} className="py-2 px-2 border-0 rounded ms-2">
                  <img src="images/dashboard-images/invoice.svg" />
                </button>
              </Link>
            </div>
          ),
      },
    ];

    const defaultSorted = [
      {
        dataField: "id",
        order: "asc",
      },
    ];

    const pageOptions = {
      paginationSize: 5,
      pageStartIndex: 1,
      firstPageText: "First",
      prePageText: "Back",
      nextPageText: "Next",
      lastPageText: "Last",
      nextPageTitle: "First page",
      prePageTitle: "Pre page",
      firstPageTitle: "Next page",
      lastPageTitle: "Last page",
      onPageChange: (page, limit) => {
        this.setState({ page: page }, () => this.getStockList());
      },
      sizePerPageOptionRenderer: ({ text, page, onSizePerPageChange }) => {
        return (
          <li key={text} role="presentation" className="dropdown-item">
            <a
              href="#"
              className="text-dark"
              tabIndex="-1"
              role="menuitem"
              data-page={page}
              onMouseDown={e => {
                onSizePerPageChange(page);
                this.setState({ page: 1, sizePerPage: page }, () =>
                  this.getStockList()
                );
              }}
            >
              {text}
            </a>
          </li>
        );
      },
      sizePerPageList: [10, 25, 50, 100],
      page: this.state.page,
      totalSize: this.state.totalSize, // replace later with size(customers),
      custom: true,
    };

    const { SearchBar } = Search;

    const { history } = this.props;

    document.title = "admin-report";

    return (
      <PaginationProvider
        pagination={paginationFactory(pageOptions)}
        keyField="id"
        columns={columns}
        data={this.state.ledgerList}
      >
        {({ paginationProps, paginationTableProps }) => (
          <ToolkitProvider
            keyField="id"
            columns={columns}
            data={this.state.ledgerList}
            search
          >
            {toolkitProps => (
              <React.Fragment>
                <div className="page-content">
                  <div className="container-fluid">
                    <h3 className="text-black fw-bold text-uppercase">
                      {this.props.t("TRANSACTIONS")}
                    </h3>
                    <Row>
                      <Col className="col-12 mt-3">
                        <Card>
                          <CardBody>
                            <div className="d-xxl-flex d-block justify-content-between text-center text-xxl-start">
                              <div className="">
                                <h3 className="text-black fw-bold">
                                  {this.props.t("Transaction List")}
                                </h3>
                              </div>

                              <div className="pt-3 pt-xxl-0">
                                <label
                                  htmlFor="date"
                                  className="fs-5 fw-bold text-black pe-3"
                                >
                                  {this.props.t("From Date")}:
                                </label>
                                <input
                                  type="date"
                                  className="fs-5 text-black border-0    "
                                  name="date"
                                  value={this.state.fromDate}
                                  onChange={e =>
                                    this.setState(
                                      { fromDate: e.target.value },
                                      () => this.getStockList()
                                    )
                                  }
                                />
                                <label
                                  htmlFor="date"
                                  className="fs-5 fw-bold px-0 px-md-3 text-black"
                                >
                                  {this.props.t("To Date")}:
                                </label>
                                <input
                                  type="date"
                                  className="fs-5 text-black border-0"
                                  name="date"
                                  value={this.state.toDate}
                                  onChange={e =>
                                    this.setState(
                                      { toDate: e.target.value },
                                      () => this.getStockList()
                                    )
                                  }
                                />
                              </div>

                              <div className="pt-3 pt-xxl-0">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <label
                                      htmlFor="search"
                                      className="pt-2 fs-5 pe-1 pe-lg-3"
                                    >
                                      {this.props.t("Select Party")}
                                    </label>
                                    <AsyncSelect
                                      id="partyId"
                                      className="officestock-select d-inline-block"
                                      onChange={e => {
                                        this.setState(
                                          {
                                            partyId: e.value,
                                            stockList: [],
                                            page: 1,
                                            sizePerPage: 10,
                                          },
                                          () => this.getStockList()
                                        );
                                      }}
                                      loadOptions={promiseOptions}
                                      defaultOptions={[
                                        { label: "All", value: "" },
                                        ...this.state.partyList.map(x => {
                                          return {
                                            value: x.id,
                                            label: x.name,
                                          };
                                        }),
                                      ]}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="d-xxl-flex pt-4 d-block text-center text-xxl-start justify-content-between">
                              <div>
                                <div className="pt-3 pt-xxl-0">
                                  <p className="d-inline pe-3 fs-5">
                                    {this.props.t("Show")}
                                  </p>
                                  <div className="d-inline">
                                    <SizePerPageDropdownStandalone
                                      className=""
                                      {...paginationProps}
                                    />
                                  </div>
                                  <p className="d-inline ps-3 fs-5">
                                    {this.props.t("entries")}
                                  </p>
                                </div>
                              </div>
                              <div className="pt-3 pt-xxl-0">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <label
                                      htmlFor="search"
                                      className="pt-2 fs-5 pe-1 pe-lg-3"
                                    >
                                      {this.props.t("Search Factory")}
                                    </label>
                                    <AsyncSelect
                                      id="factoryId"
                                      className="officestock-select d-inline-block"
                                      onChange={e => {
                                        this.setState(
                                          {
                                            factoryId: e.value,
                                            stockList: [],
                                            page: 1,
                                            sizePerPage: 10,
                                          },
                                          () => this.getStockList()
                                        );
                                      }}
                                      loadOptions={promiseOptionsFactory}
                                      defaultOptions={[
                                        { label: "All", value: "" },
                                        ...this.state.factoryList.map(x => {
                                          return {
                                            value: x.id,
                                            label: x.name,
                                          };
                                        }),
                                      ]}
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="pt-3 pt-xxl-0">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <label
                                      htmlFor="search"
                                      className="pt-2 fs-5 pe-1 pe-lg-3"
                                    >
                                      {this.props.t("Search Ledger ID")}
                                    </label>
                                    <AsyncSelect
                                      id="jangadId"
                                      className="officestock-select d-inline-block"
                                      onChange={e => {
                                        this.setState(
                                          {
                                            orderId: e.value,
                                            stockList: [],
                                            page: 1,
                                            sizePerPage: 10,
                                          },
                                          () => {
                                            if (e.value == "") {
                                              this.getJangadList(null);
                                            }
                                            this.getStockList();
                                          }
                                        );
                                      }}
                                      loadOptions={promiseOptionsOrder}
                                      defaultOptions={[
                                        { label: "All", value: "" },
                                        ...this.state.orderList.map(x => {
                                          return {
                                            label: x.id,
                                            value: x.id,
                                          };
                                        }),
                                      ]}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="d-xxl-flex pt-4 d-block text-center text-xxl-start justify-content-between">
                              <div className="pt-3 pt-xxl-0">
                                <label
                                  htmlFor="search"
                                  className="pt-2 fs-5 pe-1 pe-lg-3"
                                >
                                  {this.props.t("Print Status")}
                                </label>

                                <Select
                                  onChange={e => {
                                    this.setState(
                                      {
                                        printStatus: e.value,
                                        stockList: [],
                                        page: 1,
                                        sizePerPage: 10,
                                      },
                                      () => {
                                        this.getStockList();
                                      }
                                    );
                                  }}
                                  aria-labelledby="aria-label"
                                  className="officestock-select d-inline-block"
                                  inputId="aria-example-input"
                                  name="aria-live-color"
                                  onMenuOpen={this.onMenuOpen}
                                  onMenuClose={this.onMenuClose}
                                  options={[
                                    { label: "All", value: "" },
                                    { label: "Yes", value: "Yes" },
                                    { label: "No", value: "No" },
                                  ]}
                                />
                              </div>
                              <div className="pt-3 pt-xxl-0">
                                <label
                                  htmlFor="search"
                                  className="pt-2 fs-5 pe-1 pe-lg-3"
                                >
                                  {this.props.t("Payment Status")}
                                </label>

                                <Select
                                  onChange={e => {
                                    this.setState(
                                      {
                                        paymentStatus: e.value,
                                        stockList: [],
                                        page: 1,
                                        sizePerPage: 10,
                                      },
                                      () => {
                                        this.getStockList();
                                      }
                                    );
                                  }}
                                  aria-labelledby="aria-label"
                                  className="officestock-select d-inline-block"
                                  inputId="aria-example-input"
                                  name="aria-live-color"
                                  onMenuOpen={this.onMenuOpen}
                                  onMenuClose={this.onMenuClose}
                                  options={[
                                    { label: "All", value: "" },
                                    { label: "Paid", value: "Paid" },
                                    {
                                      label: "Pending",
                                      value: "Pending",
                                    },
                                    {
                                      label: "Partial Paid",
                                      value: "PartialPaid",
                                    },
                                  ]}
                                />
                              </div>
                              <div className="pt-3 pt-xxl-0">
                                <label
                                  htmlFor="search"
                                  className="pt-2 fs-5 pe-1 pe-lg-3"
                                >
                                  {this.props.t("Approve Status")}
                                </label>

                                <Select
                                  onChange={e => {
                                    this.setState(
                                      {
                                        approveStatus: e.value,
                                        stockList: [],
                                        page: 1,
                                        sizePerPage: 10,
                                      },
                                      () => {
                                        this.getStockList();
                                      }
                                    );
                                  }}
                                  aria-labelledby="aria-label"
                                  className="officestock-select d-inline-block"
                                  inputId="aria-example-input"
                                  name="aria-live-color"
                                  onMenuOpen={this.onMenuOpen}
                                  onMenuClose={this.onMenuClose}
                                  options={[
                                    { label: "All", value: "" },
                                    { label: "Yes", value: "Yes" },
                                    {
                                      label: "Pending",
                                      value: "Pending",
                                    },
                                    {
                                      label: "No",
                                      value: "No",
                                    },
                                  ]}
                                />
                              </div>
                            </div>
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    remote={true}
                                    onTableChange={() => false}
                                    keyField={"id"}
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    defaultSorted={defaultSorted}
                                    classes={"table align-middle table-nowrap"}
                                    headerWrapperClasses={"thead-light"}
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                  />
                                </div>
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                    <Col className="inner-custom-pagination mt-4 d-flex justify-content-between">
                      <div className="">
                        <h5>
                          {this.props.t("Showing")}{" "}
                          {(this.state.page - 1) * this.state.sizePerPage + 1} -{" "}
                          {this.state.totalSize < this.state.sizePerPage
                            ? this.state.totalSize
                            : this.state.sizePerPage * this.state.page >=
                              this.state.totalSize
                            ? this.state.totalSize
                            : this.state.sizePerPage * this.state.page}{" "}
                          of {this.state.totalSize}
                        </h5>
                      </div>
                      <div className="ms-auto">
                        <PaginationListStandalone {...paginationProps} />
                      </div>
                    </Col>
                  </div>
                </div>
              </React.Fragment>
            )}
          </ToolkitProvider>
        )}
      </PaginationProvider>
    );
  }
}

export default withTranslation()(TransactionList);
